import { helpers, required as req } from "@vuelidate/validators";

import { QuestionType, useQuizQuestionsStore } from "@/store/quiz-questions";

import {
  Question,
  QuestionTrueFalse,
  QuestionDragDrop,
  QuestionGap,
} from "@/models/quiz.model";
import { required } from "@/locale/locale.config";

import { useQuizQuestionsDragNDropStore } from "@/store/quiz-question-drag";
import { useQuizQuestionsGapStore } from "@/store/quiz-question-gap";
import { CourseType } from "@/models/courses.model";

export class QuestionFactory {
  static getType(): QuestionType {
    return JSON.parse(localStorage.getItem("question-type") as string);
  }

  static formQuestion():
    | Question
    | QuestionTrueFalse
    | QuestionDragDrop
    | QuestionGap {
    const type = this.getType();
    switch (type) {
      case QuestionType.TRUE_OR_FALSE:
        return new QuestionTrueFalse();

      case QuestionType.DRAG_AND_DROP:
        return new QuestionDragDrop();
      case QuestionType.FILL_IN_THE_BLANKS:
        return new QuestionGap();
      default:
        return new Question();
    }
  }
  static selectStore(): any {
    const type = this.getType();
    switch (type) {
      case QuestionType.DRAG_AND_DROP:
        return useQuizQuestionsDragNDropStore;
      case QuestionType.FILL_IN_THE_BLANKS:
        return useQuizQuestionsGapStore;
      case QuestionType.TRUE_OR_FALSE:
      default:
        return useQuizQuestionsStore;
    }
  }
  static rules(course: any) {
    const type = this.getType();
    switch (type) {
      case QuestionType.TRUE_OR_FALSE:
        return {
          form: {
            contents:
              course?.type === CourseType.ADAPTATIVE ? { required } : {},
            prompt: { required },
            materialReferences: {
              $each: helpers.forEach({
                referenceTime: { req },
              }),
            },
            items: {
              $each: helpers.forEach({
                answerText: { req },
                answerDescription:
                  course?.type === CourseType.ADAPTATIVE ? { req } : {},
                correctAnswer: { req },
              }),
            },
          },
        };
      case QuestionType.DRAG_AND_DROP:
        return {
          form: {
            contents:
              course?.type === CourseType.ADAPTATIVE ? { required } : {},
            prompt: { required },
            materialReferences: {
              $each: helpers.forEach({
                referenceTime: { req },
              }),
            },
            items: {
              $each: helpers.forEach({
                answerText: { req },
                correctOptions: {
                  $each: helpers.forEach({
                    req,
                  }),
                },
              }),
            },
          },
        };
      case QuestionType.FILL_IN_THE_BLANKS:
        return {
          form: {
            contents:
              course?.type === CourseType.ADAPTATIVE ? { required } : {},
            prompt: { required },
            materialReferences: {
              $each: helpers.forEach({
                referenceTime: { req },
              }),
            },
            items: {
              $each: helpers.forEach({
                answerText: { req },
                correctOptions: {
                  $each: helpers.forEach({
                    req,
                  }),
                },
              }),
            },
          },
        };
      default:
        return {
          form: {
            contents:
              course?.type === CourseType.ADAPTATIVE ? { required } : {},
            prompt: { required },
            materialReferences: {
              $each: helpers.forEach({
                referenceTime: { req },
              }),
            },
            items: {
              $each: helpers.forEach({
                answerText: { req },
                answerDescription:
                  course?.type === CourseType.ADAPTATIVE ? { req } : {},
                correct: { req },
              }),
            },
          },
        };
    }
  }
}
